<template>
    <div v-if="document && document.url" class="hide-long-text">
        <a :href="document.url"
           target="_blank">
            <span>
                <font-awesome-icon :icon="documentIcon"/>
            </span>
            {{ name }}
        </a>
    </div>
</template>

<script>
export default {
    name: "DocumentListItem",
    props: {
        document: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    },
    computed: {
        documentIcon() {
            let extension = this.document.url.split('.').pop();
            switch (extension) {
                case "pdf":
                    return "file-pdf"
                case "docx":
                case "docm":
                case "doc":
                case "odt":
                    return "file-word"
                case "xls":
                case "xlsx":
                case "ods":
                case "csv":
                case "tsv":
                case "dat":
                    return "file-excel"
                case "png":
                case "gif":
                case "jpg":
                case "jpeg":
                case "svg":
                case "bmp":
                case "odi":
                    return "file-image"
                default:
                    return "file-alt"
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.hide-long-text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.hide-long-text:hover {
    text-overflow: clip;
    overflow: visible;

    > a {
        position: relative;
        background: white;
        z-index: 2;
        padding-right: .5em;
    }
}
</style>
